import React from "react";
import Header from "../Header/index";
import { Layout } from "nq-component";

function Head(props) {
  const { collapsed, setCollapse } = React.useContext(Layout.Context);

  function onClickNavigate() {
    setCollapse(!collapsed);
  }

  return (
    <Header
      className="shadow-sm"
      // title="DASHBOARD"
      onClickNavigate={onClickNavigate}
      {...props}
    />
  );
}

export default Head;
